<template>
    <div class="rounded-2xl border-2 border-gray-100 shadow-lg">
        <slot/>
    </div>
</template>